import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import React from "react";
const useDeprecatedWarning = (message, dependencies) => {
  React.useEffect(() => {
    const shouldWarn = _filterInstanceProperty(dependencies).call(dependencies, i => i).length > 0;
    if (shouldWarn) process.env.NODE_ENV !== 'production' ? console.warn(`Deprecated: ${message}`) : void 0;
  }, dependencies);
};
export default useDeprecatedWarning;